var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M484.375 96C407 96 349.25 164.125 320 208.5C290.75 164.125 233 96 155.625 96C69.75 96 0 167.75 0 256S69.75 416 155.625 416C233.125 416 290.75 347.875 320 303.5C349.25 347.875 407 416 484.375 416C570.25 416 640 344.25 640 256S570.25 96 484.375 96ZM155.625 368C96.25 368 48 317.75 48 256S96.25 144 155.625 144C223.375 144 276.125 226.25 292.75 256C276 285.75 223.375 368 155.625 368ZM484.375 368C416.625 368 363.875 285.75 347.25 256C364 226.25 416.625 144 484.375 144C543.75 144 592 194.25 592 256S543.75 368 484.375 368Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.ede5acd772437c543bcf2b565d3feb08.svg";
export { ForwardRef as ReactComponent };